import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import MediaPanel from '../../../../components/Editor/EditPanel/MediaPanel';
import { EditorType } from '../../constants';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			type: editorType,
			activeItem: { id },
			isAccessibleVersion,
		},
		importManager: { byId },
	} = state;

	const { page, editableMediaItem } = ownProps;

	const {
		label,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
		frameWidth,
		frameHeight,
		importManagerId,
	} = editableMediaItem;

	return {
		page,
		id,
		label,
		defaultLink,
		driveLink,
		externalLink,
		isExternalLinkActive,
		frameWidth,
		frameHeight,
		importManagerId,
		isImporting: !!byId[importManagerId],
		isPercentageValues: editorType === EditorType.HTML,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(MediaPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/MediaPanel/index.tsx